import LargeMap from '@Core/components/largeMap';
import LocationCard from '@Core/components/largeMap/locationCard';
import { ComponentLoader } from '@Component';

export default class geoPageLayout {
  constructor() {
    this.$container = document.getElementById('mapLayout');
    this.initalizeMap();
  }

  /**
   * Create a new Map map using the largeMap class.
   * Also attaches necessary event listeners and adds map markers
   * given a list of locations.
   */
  initalizeMap() {
    this.largeMap2 = new LargeMap(this.$container.querySelector(LargeMap.selector));
    window.locationCards = new ComponentLoader(document, [
      [
        LocationCard,
        {
          map: this.largeMap2,
          activeClass: 'location-listing--active',
        },
      ],
    ],
    () => {
      this.largeMap2.fitBounds();
      window.setTimeout(() => this.largeMap2.fitBounds(), 500);
    });
  }
}
